import React, { FC }  from 'react';
import { graphql } from 'gatsby';
import Top from './Top';
import { Wrapper } from './styled';

interface Props {
  locale: string;
}

const NavbarHome: FC<Props & Queries.SeoNavbarFragment> = ({ navbar, locale }) => {
  return (
    <Wrapper>
      <Top navbar={navbar} locale={locale} />
    </Wrapper>
  );
};

export const query = graphql`
  fragment SeoNavbar on Json {
    navbar {
      buttonText
      buttonLink
      loginButton
      logoImage {
        src
        alt
      }
      animatedLogo {
        src
      }
      navbarList {
        key
        text
        link
        openNewTab
        children {
          key
          text
          link
          openNewTab
        }
      }
      navbarMobileList {
        key
        text
        link
        openNewTab
      }
    }
  }
`;

export default NavbarHome;
